import { NARRATIVE_CARD_FRAGMENT } from '@/components/NarrativeCard';
import { gql } from '@/utilities/gql';
import { makeGqlSuspenseQuery } from '@/utilities/gqlQuery';

const QUERY = gql(
  `
  query NarrativesWeeklyPicks {
    narrativeWeeklyPicks {
      ...NarrativeCardFields
    }
  }
`,
  [NARRATIVE_CARD_FRAGMENT]
);

export const useNarrativeWeeklyPicks = makeGqlSuspenseQuery(QUERY, {
  tags: ['narrative', 'narrative-weekly-picks'],
  staleTime: 0,
});
